import axios from "axios";

const END_POINT = '/api/plans';

const fetchPlans = (query) =>  axios.get(END_POINT + query);

export {
    fetchPlans,
}
